module.exports = __webpack_public_path__ + "media/images/shared/suppliers/OEGERMANY-932dace3c58bc03b1bec0c4dba63bd66.jpg";